export default __webpack_public_path__ + "static/media/footer-whatsapp-icon.2c98e3e0.svg";